import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilityService } from '../utility.service';
import { DynamicFormUtilityServices } from '../dynamic-form-utility.service';
import { FormSearch } from 'app/models/dashboard/FormStatus';
import { BaseDashboard } from 'app/models/dashboard/BaseDashboard';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AssetWorkOrderFormService {
	private readonly urlPath = `${environment.apiUrl}capital-assets/clients/`;

	constructor(
		private httpClient: HttpClient,
		private utilityService: UtilityService,
		private dynamicFormUtilityServices: DynamicFormUtilityServices
	) {}

	createForm(clientId: string, request: any, dynamicPrefixLabel = ''): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/work-order`, this.setupRequest(request, dynamicPrefixLabel))
			.pipe();
	}
	private setupRequest(request: any, dynamicPrefixLabel = '') {
		const formData: FormData = new FormData();

		formData.append('model', JSON.stringify(request));
		// Dynamic Work Order Info file fields hold the real File on the request; append them so the bytes reach the server.
		if (request?.additionalField?.dynamicFormMultipleTypeConfigurations) {
			this.dynamicFormUtilityServices.appendMultipleTypeDocuments(formData, dynamicPrefixLabel, request);
		}
		return formData;
	}

	updateForm(clientId: string, id: string, request: any, dynamicPrefixLabel = ''): Observable<any> {
		return this.httpClient
			.put<any>(`${this.urlPath}${clientId}/work-order/${id}`, this.setupRequest(request, dynamicPrefixLabel))
			.pipe();
	}

	getForm(clientId: string, id: string): Observable<any> {
		return this.httpClient.get<any>(`${this.urlPath}${clientId}/work-order/${id}`).pipe();
	}

	rejectForm(clientId: string, id: string, rejectionReason: { reason: string; workflowId: number }): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/work-order/${id}/decline`, rejectionReason).pipe();
	}

	approveForm(clientId: string, id: string, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/work-order/${id}/approve`, {
				userId,
			})
			.pipe();
	}

	getFormsFor(clientId: string, userId: string, search: FormSearch): Observable<BaseDashboard<any>> {
		let url = `${this.urlPath}${clientId}/work-order/users/${userId}?${this.utilityService.objectToQueryString(
			search
		)}`;
		return this.httpClient.get<BaseDashboard<any>>(url).pipe();
	}

	sendBack(clientId: string, id: string): Observable<any> {
		return this.httpClient.post<any>(`${this.urlPath}${clientId}/work-order/${id}/review`, {}).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.urlPath}${clientId}/work-order/${id}/approval`, {
				userId,
			})
			.pipe();
	}
}
